module.exports = __webpack_public_path__ + "static/media/IconeRoboDelivery.58b84f82.svg";